// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__-Ppj1"};